/**
 * P1 — flat-rate (Pest Control / Lawn Care) quote totals.
 *
 * Tax comes SOLELY from the company's `settings/billing` rate (threaded in as
 * `taxRate`; 0 when disabled/unset). Never a calculator-specific default and
 * never the legacy 6.35 CT rate. Pure + dependency-free so it is unit-testable
 * and safe to share.
 */
export function computeFlatRateTotals(base, materials, taxRate) {
  const subtotal = (parseFloat(base) || 0) + (parseFloat(materials) || 0);
  const rate = parseFloat(taxRate) > 0 ? parseFloat(taxRate) : 0;
  const tax = parseFloat((subtotal * rate / 100).toFixed(2));
  return { subtotal, rate, tax, grandTotal: subtotal + tax };
}
